import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Çerez politikasının kabul veya reddedilme durumunu kontrol et
    const isCookieAccepted = localStorage.getItem("cookieAccepted");
    const isCookieDeclined = localStorage.getItem("cookieDeclined");

    if (!isCookieAccepted && !isCookieDeclined) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    // Kullanıcı çerez politikasını kabul ettiğinde durumu kaydet
    localStorage.setItem("cookieAccepted", "true");
    setShowBanner(false);
  };

  const handleDecline = () => {
    // Kullanıcı çerez politikasını reddettiğinde durumu kaydet
    localStorage.setItem("cookieDeclined", "false");
    setShowBanner(false);
  };

  return (
    showBanner && (
      <div style={styles.banner}>
        <p>
          Bilgi Güvenliği Süreçlerinin Yürütülmesi, İş Faaliyetlerinin
          Yürütülmesi / Denetimi, İş Sürekliliğinin Sağlanması Faaliyetlerinin
          Yürütülmesi, Pazarlama Analiz Çalışmalarının Yürütülmesi, Reklam /
          Kampanya / Promosyon Süreçlerinin Yürütülmesi ve Ürün / Hizmetlerin
          Pazarlama Süreçlerinin Yürütülmesi için, LENSA
          Sanayi Ve Ticaret Anonim Şirketi olarak amaçlarla sınırlı ve gizliliğe
          uygun şekilde çerez konumlandırmaktayız. Çerezleri nasıl
          kullandığımızı incelemek için
          <Link className="font-bold" to="/cerez-aydinlatma-metni">
            {" "}
            Çerez Aydınlatma Metnimizi
          </Link>{" "}
          inceleyebilir, çerez kategorilerini, çerez özelliklerini ve kullanım
          amaçlarını öğrenebilirsiniz.
        </p>
        <div style={styles.buttonContainer}>
          <button onClick={handleAccept} style={styles.acceptButton}>
            Kabul Et
          </button>
          <button onClick={handleDecline} style={styles.declineButton}>
            Reddet
          </button>
        </div>
      </div>
    )
  );
};

const styles = {
  banner: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    background: "#000",
    color: "#fff",
    padding: "20px",
    textAlign: "center",
    zIndex: 9999,
    fontSize: "14px",
    lineHeight: "1.5",
  },
  buttonContainer: {
    marginTop: "10px",
  },
  acceptButton: {
    background: "#4CAF50",
    color: "#fff",
    padding: "10px 20px",
    marginRight: "10px",
    border: "none",
    cursor: "pointer",
  },
  declineButton: {
    background: "#f44336",
    color: "#fff",
    padding: "10px 20px",
    border: "none",
    cursor: "pointer",
  },
};

export default CookieBanner;
